<template>
  <v-card class="mx-auto fill-height" variant="outlined" color="primary">
    <v-toolbar :flat="true" color="primary">
      <v-toolbar-title class="text-white">
        {{ $t("labels.kpi-and-measures") }}

        <div class="text-caption text-truncate">
          {{ $t("strings.kpi-and-measures-hint") }}
          <v-tooltip activator="parent" location="top">
            {{ $t("strings.kpi-and-measures-hint") }}
          </v-tooltip>
        </div>
      </v-toolbar-title>
    </v-toolbar>
    <v-card-text class="pa-0">
      <v-virtual-scroll
        :height="itemsVirtualHeight"
        :items="selectedItems"
        item-height="64px"
      >
        <template v-slot:default="{ item }">
          <v-list-item class="border-b-sm">
            <template v-slot:prepend>
              <v-icon color="primary darken-4">
                {{ checkIcon(item) }}
              </v-icon>
            </template>

            <v-list-item-title>
              <div
                draggable="true"
                @dragstart="dragStart($event)"
                class="d-flex align-center"
              >
                <span>{{ item.name }}</span>
              </div>
            </v-list-item-title>
            <v-list-item-subtitle
              v-if="item.description"
              class="d-inline-block text-truncate w-100"
            >
              {{ item.description }}
            </v-list-item-subtitle>
          </v-list-item>
        </template>
      </v-virtual-scroll>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: "FormulaItems",
  props: ["containerHeight", "selectedItems"],
  data() {
    return {
      tooltipText: null, // State for tooltip text
    };
  },
  methods: {
    checkIcon(item) {
      return item.type == "kpi" ? "mdi-gauge" : "mdi-ruler";
    },
    dragStart(e) {
      e.dataTransfer.setData("text/plain", e.target.innerText);
    },
  },
  computed: {
    itemsVirtualHeight() {
      try {
        // Use a fixed calculation to avoid triggering unnecessary reflows
        const toolbarHeight = 68; // Fixed height of the toolbar
        const paddingHeight = 52; // Fixed padding or margin
        return `calc(${this.containerHeight} - ${toolbarHeight}px - ${paddingHeight}px)`;
      } catch (error) {
        console.error("Error calculating itemsVirtualHeight:", error);
        return "100%"; // Fallback to full height
      }
    },
  },
};
</script>
